export default __webpack_public_path__ + "static/media/BDIC blong dolly Brochure11 1.5955ad6a.png";